import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ef5c65f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "account-auth"
};
const _hoisted_2 = {
  class: "card personal"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h2 class=\"card-title\" data-v-ef5c65f6>个人认证</h2><p class=\"card-desc\" data-v-ef5c65f6>完成账号认证，就可以发布众筹啦</p><div class=\"tips\" data-v-ef5c65f6><div class=\"tips-title\" data-v-ef5c65f6>认证资料准备：</div><div class=\"tips-line\" data-v-ef5c65f6>本人手持身份证的半身照，需包含身份证正反面</div><div class=\"tips-sub\" data-v-ef5c65f6>＊ 身份证人像面、国徽面信息均可清晰识别</div></div>", 3);
const _hoisted_6 = /*#__PURE__*/_createTextVNode("立即认证");
const _hoisted_7 = {
  class: "card enterprise"
};
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<h2 class=\"card-title\" data-v-ef5c65f6>企业认证</h2><p class=\"card-desc\" data-v-ef5c65f6>完成账号认证，就可以发布众筹啦</p><div class=\"tips\" data-v-ef5c65f6><div class=\"tips-title\" data-v-ef5c65f6>认证资料准备：</div><div class=\"tips-line\" data-v-ef5c65f6>1、营业执照原件扫描件或加盖公司鲜章的复印件</div><div class=\"tips-line\" data-v-ef5c65f6>2、企业法人的身份证照片</div><div class=\"tips-sub\" data-v-ef5c65f6>＊ 资料图片需清晰完整，且在有效期内</div></div>", 3);
const _hoisted_11 = /*#__PURE__*/_createTextVNode("立即认证");
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<section class=\"notice\" data-v-ef5c65f6><h3 class=\"notice-title\" data-v-ef5c65f6>注意事项</h3><div class=\"notice-inner\" data-v-ef5c65f6><div class=\"notice-line\" data-v-ef5c65f6>1、 申请创意和众筹项目前，需先完成账号认证</div><div class=\"notice-line\" data-v-ef5c65f6>2、 项目结算款项仅限提现至开户名称与认证主体名称一致的银行账户</div><div class=\"notice-line\" data-v-ef5c65f6>3、 账号认证审核通过后，不支持修改；每6个月进行一次账号审核</div></div></section>", 1);
import { useRouter } from 'vue-router';
export default {
  setup(__props) {
    const router = useRouter();
    const goVerify = () => {
      router.push('/identity/verify');
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_hoisted_3, _createVNode(_component_van_button, {
        type: "primary",
        class: "btn",
        block: "",
        onClick: goVerify
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      })]), _createElementVNode("section", _hoisted_7, [_hoisted_8, _createVNode(_component_van_button, {
        type: "primary",
        class: "btn enterprise-btn",
        block: "",
        onClick: goVerify
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      })]), _hoisted_12]);
    };
  }
};